import { AnyAction } from 'redux';
import { AccountProfile } from '../types/accountProfile';

export interface LoginState {
  authenticated: boolean;
  failed: boolean;
  userData: AccountProfile;
  isLoading: boolean;
  smsVerificationDialogShow: boolean;
  userViberConfig: {
    ONE_TO_ONE: boolean;
    CAMPAIGN: boolean;
    ACTIVE: boolean;
  };
  userWhatsappConfig: {
    ONE_TO_ONE: boolean;
    CAMPAIGN: boolean;
    ACTIVE: boolean;
  };
}

const initialState: LoginState = {
  authenticated: false,
  failed: false,
  userData: {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    customerName: '',
    authorizations: {},
    customerCurrency: '',
    customerCountry: '',
    customerRegion: '',
    customerCity: '',
    customerAddress: '',
    customerPostalCode: '',
    message: '',
    chatAgent: false,
    hasWB: false,
    hasVB: false,
    chatAgentStatus: undefined,
    customerId: undefined,
    customerUuid: '',
    permissions: {},
    isPasswordExpired: false,
    userName: '',
    token: '',
    useStaticSenderId: false,
    defaultTimeZone: '',
    _links: {
      self: { href: '' },
      user: { href: '' },
      logo: { href: '' },
      reseller: { href: '' },
      appearance: { href: '' },
      account_info: { href: '' },
    },
  },
  isLoading: false,
  smsVerificationDialogShow: false,
  userViberConfig: {
    ONE_TO_ONE: false,
    CAMPAIGN: false,
    ACTIVE: false,
  },
  userWhatsappConfig: {
    ONE_TO_ONE: false,
    CAMPAIGN: false,
    ACTIVE: false,
  },
};

export default function reducer(state: LoginState = initialState, action: AnyAction): LoginState {
  switch (action.type) {
    case 'REFRESH_LOGIN_PAGE': {
      return {
        ...state,
        authenticated: false,
        // @ts-expect-error TODO: type { message: string } is missing, but it's defined
        userData: {
          message: 'empty',
        },
      };
    }

    case 'IS_AUTHENTICATED': {
      const { payload } = action;
      return {
        ...state,
        authenticated: true,
        failed: false,
        userData: {
          ...state.userData,
          ...payload,
        },
      };
    }
    case 'IS_NOT_AUTHENTICATED': {
      return {
        ...state,
        authenticated: false,
      };
    }
    case 'LOGIN_SUCCESS': {
      const { payload } = action;
      return {
        ...state,
        authenticated: true,
        failed: false,
        userData: {
          ...state.userData,
          ...payload,
        },
        isLoading: false,
      };
    }
    case 'LOGIN_FAILED': {
      return {
        ...state,
        authenticated: false,
        failed: true,
        userData: action.payload,
        isLoading: false,
      };
    }
    case 'CHANGE_PW_FAILED': {
      const { payload } = action;
      return {
        ...state,
        authenticated: true,
        failed: true,
        userData: {
          ...state.userData,
          ...payload,
        },
        isLoading: false,
      };
    }
    case 'LOGIN_EMPTY': {
      return {
        ...state,
        authenticated: false,
        failed: true,
        userData: action.payload,
      };
    }
    case 'LOGIN_START': {
      return {
        ...state,
        isLoading: true,
      };
    }
    case 'LOGIN_STOP': {
      return {
        ...state,
        isLoading: false,
      };
    }
    case 'CLEAN_FAILED': {
      return {
        ...state,
        failed: false,
      };
    }
    case 'SET_SMS_VERIFICATION_CODE_DIALOG_SHOW': {
      return {
        ...state,
        smsVerificationDialogShow: action.payload,
      };
    }
    case 'SMS_VERIFICATION_FAILED': {
      return {
        ...state,
        authenticated: false,
        failed: true,
      };
    }
    case 'SET_USER_VIBER_CONFIG': {
      return {
        ...state,
        userViberConfig: action.payload,
      };
    }
    case 'SET_USER_WHATSAPP_CONFIG': {
      return {
        ...state,
        userWhatsappConfig: action.payload,
      };
    }
    default:
      return {
        ...state,
      };
  }
}
